export const iconFontAwesomeEmojiFaceDizzy = (
	<i className="fa-solid fa-face-dizzy"></i>
);
